module.exports = __webpack_public_path__ + "img/img_32389_0_482.35a856a2.png";